// extracted by mini-css-extract-plugin
module.exports = {"Nav_Links":"sideDrawerList_Nav_Links__3qaGj","Items":"sideDrawerList_Items__1_oVc","Services":"sideDrawerList_Services__1k8vr"};